/* URS2GO top bar countdown — decorative, mirrors sunbeauty's
   "Next rotation in Ns" + green progress bar. Single clock drives
   both the number and the bar width so they never drift apart. */
if (!customElements.get('urs2go-topbar')) {
  customElements.define('urs2go-topbar', class extends HTMLElement {
    connectedCallback() {
      const intervalMs = parseInt(this.dataset.interval || '100000', 10);
      const totalSec = Math.max(1, Math.round(intervalMs / 1000));
      let seconds = totalSec;
      const countdownEl = this.querySelector('[data-topbar-countdown]');
      const progressEl = this.querySelector('[data-topbar-progress]');

      const render = () => {
        if (countdownEl) countdownEl.textContent = String(seconds);
        if (progressEl) progressEl.style.transform = 'scaleX(' + (seconds / totalSec) + ')';
      };
      render();

      setInterval(() => {
        seconds -= 1;
        if (seconds <= 0) {
          seconds = totalSec;
          /* 每绕完一圈 = 一个轮换周期。首页产品轮换监听这个事件，
             这样「倒计时条」与「首页换一批」永远在同一条 clock line 上。 */
          document.dispatchEvent(new CustomEvent('urs2go:rotation'));
        }
        render();
      }, 1000);
    }
  });
}

/* URS2GO banner rotator — cross-fades the artwork layers listed in the
   "Rotating banner assets" setting. A single layer stays put. */
if (!customElements.get('urs2go-banner-rotator')) {
  customElements.define('urs2go-banner-rotator', class extends HTMLElement {
    connectedCallback() {
      const layers = Array.from(this.querySelectorAll('.urs2go-topbar__banner-layer'));
      if (layers.length < 2) return;
      const intervalMs = Math.max(2000, parseInt(this.dataset.interval || '100000', 10));
      /* 2026-10-05（用户：「首屏也随机」）：服务端现在用时间戳随机选首屏那一张，
         所以不能再假定 active 是第 0 层 —— 从真正 active 的那层接着往下转。 */
      const activeIdx = layers.findIndex((l) => l.classList.contains('is-active'));
      let i = activeIdx >= 0 ? activeIdx : 0;
      const tick = () => {
        layers[i].classList.remove('is-active');
        /* 2026-10-04/05（用户令）：随机轮换（不打乱顺序也不循环），且不连续重复同一张。
           首屏那张由服务端随机决定（见 Liquid 里的时间戳取模），客户端不再改动它，避免加载瞬间闪。 */
        let next = i;
        if (layers.length > 1) {
          while (next === i) next = Math.floor(Math.random() * layers.length);
        }
        i = next;
        layers[i].classList.add('is-active');
      };
      /* 2026-10-04（用户报「不轮换了」）：原实现用 setInterval + visibility 暂停，
         回到前台要等满一个 interval（50s）才动 —— 看着像坏了。
         改成 setTimeout 链：隐藏时取消，回前台 4s 内先换一张，再恢复常规间隔。 */
      const RESUME_DELAY = 4000;
      let id = null;
      const schedule = (delay) => {
        id = setTimeout(() => {
          id = null;
          tick();
          if (!document.hidden) schedule(intervalMs);
        }, delay);
      };
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          if (id !== null) { clearTimeout(id); id = null; }
        } else if (id === null) {
          schedule(RESUME_DELAY);
        }
      });
      schedule(intervalMs);
    }
  });
}
